import { z } from 'zod';

/** Teamchat (Modul chat, ADR 0064). Kanäle + Direktnachrichten, Anhänge via DMS. */
export const chatChannelKindSchema = z.enum(['CHANNEL', 'DIRECT']);
export type ChatChannelKind = z.infer<typeof chatChannelKindSchema>;

/** Ein Kanal-Mitglied (Soft-Ref User + Namens-Snapshot fürs Anzeigen). */
export const chatMemberSchema = z.object({
  userId: z.string().uuid(),
  name: z.string(),
});
export type ChatMember = z.infer<typeof chatMemberSchema>;

/** Ein Kanal/eine DM in der eigenen Liste (inkl. Ungelesen-Zähler + letzte Aktivität). */
export const chatChannelResponseSchema = z.object({
  id: z.string().uuid(),
  kind: chatChannelKindSchema,
  /** Name des Kanals; bei DIRECT null (Frontend zeigt die anderen Mitglieder). */
  name: z.string().nullable(),
  description: z.string().nullable(),
  isArchived: z.boolean(),
  members: z.array(chatMemberSchema),
  unreadCount: z.number().int().nonnegative(),
  /** Zeitpunkt der letzten Nachricht (ISO) oder null (leerer Kanal). */
  lastMessageAt: z.string().datetime().nullable(),
  createdAt: z.string().datetime(),
});
export type ChatChannelResponse = z.infer<typeof chatChannelResponseSchema>;

/** Eine Chat-Nachricht. */
export const chatMessageResponseSchema = z.object({
  id: z.string().uuid(),
  channelId: z.string().uuid(),
  authorUserId: z.string().uuid(),
  authorName: z.string(),
  body: z.string(),
  createdAt: z.string().datetime(),
});
export type ChatMessageResponse = z.infer<typeof chatMessageResponseSchema>;

/** Kanal anlegen: Name + optionale Beschreibung + weitere Mitglieder (Ersteller ist immer dabei). */
export const createChatChannelSchema = z.object({
  name: z.string().trim().min(1).max(120),
  description: z.string().trim().max(500).optional(),
  memberUserIds: z.array(z.string().uuid()).max(200).default([]),
});
export type CreateChatChannelInput = z.infer<typeof createChatChannelSchema>;

/** Direktnachricht mit einem Nutzer öffnen (bestehende wird wiederverwendet). */
export const openDirectChatSchema = z.object({ userId: z.string().uuid() });
export type OpenDirectChatInput = z.infer<typeof openDirectChatSchema>;

/** Nachricht senden. */
export const postChatMessageSchema = z.object({ body: z.string().trim().min(1).max(4000) });
export type PostChatMessageInput = z.infer<typeof postChatMessageSchema>;
